import React, { useEffect, useState } from "react";
import MyNavbar from "../component/navbar";
import Navbarinner from "../component/navbarinner";
import { Col, Container, Row, Button } from "react-bootstrap";
import MyFooter from "../component/footer";
import { Doughnut } from "react-chartjs-2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { getInfo } from "../pages/buyContract";

import { referralTokens } from "../ApiAction/api";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend);
export default function Token(props) {
  const [remaning, setremaning] = useState(0)
  const [soldtokens, setsoldtokens] = useState(0)
  const labels = [
    "Play-to-Earn Rewards",
    "Development",
    "Marketing and Airdrop",
    "Presale",
    "Reserve and Liquidity",
    "Charity",
    "Public Sale / IDO",
    "Team & Founders",
  ];
  const percentages = [30, 5, 15, 2, 15, 3, 15, 15];
  const colors = [
    "#85E0A3",
    "#ffd966",
    "#ffafa3",
    "#ffc470",
    "#D9B8FF",
    "#E87AFE",
    "#FF67BB",
    "#A3FFF4",
  ];

  const data = {
    labels: labels, // Used for tooltip only
    datasets: [
      {
        data: percentages,
        backgroundColor: colors,
        hoverBackgroundColor: colors.map((color) => color + "CC"), // Slightly transparent on hover
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "55%", // Adjust inner hole size
    plugins: {
      legend: {
        display: false, // Hide default legend, using custom legend below
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) => {
            let label = labels[tooltipItem.dataIndex];
            let value = percentages[tooltipItem.dataIndex];
            return `${label}: ${value}%`;
          },
        },
      },
    },
  };
  const [firstVisible, setFirstVisible] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    cssEase: "ease-in-out",
    afterChange: (current) => {
      setFirstVisible(current);
    },
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 576) setSlidesToShow(1);
      else if (window.innerWidth < 768) setSlidesToShow(1);
      else if (window.innerWidth < 992) setSlidesToShow(2);
      else setSlidesToShow(3);
    };

    updateSlidesToShow();
    window.addEventListener("resize", updateSlidesToShow);
    return () => window.removeEventListener("resize", updateSlidesToShow);
  }, []);

  const slides = [
    {
      id: 1,
      title: "Foundation and Ecosystem Launch",
      desc: " The Foundation sets a strong base, followed by an ecosystem launch to drive growth and innovation.",
    },
    {
      id: 2,
      title: "Live Cockfight Alpha Launch",
      desc: "Live Cockfight enters Alpha, giving users early access to test real-time gameplay and features.",
    },
    {
      id: 3,
      title: " AI Bot marketplace Beta ",
      desc: "The AI Bot Marketplace goes Beta, allowing users to explore and trade AI-powered bots.",
    },
    {
      id: 4,
      title: " win powered NFT Marketplace",
      desc: "A fast and secure NFT Marketplace launches, powered by Win for seamless digital asset trading.",
    },
    {
      id: 5,
      title: "Launch crypto11",
      desc: "Crypto11 debuts with a blend of decentralized gaming and finance in one dynamic platform.",
    },
    {
      id: 6,
      title: "Wingo metaverse hub",
      desc: "The Wingo Metaverse Hub opens as a central space for immersive, Win-driven virtual experiences.",
    },
    {
      id: 7,
      title: "Decentralized SocialFi",
      desc: "SocialFi combines decentralized finance with social interaction, letting users earn as they engage.",
    },
    {
      id: 8,
      title: "Real-world utility",
      desc: "Digital assets gain real-world value through practical, everyday applications.",
    },
    {
      id: 9,
      title: "DAO",
      desc: "A DAO is a community-governed organization where decisions are made through blockchain voting.",
    },
  ];

  useEffect(() => {
    getSoldToken();
  }, []);

  async function getSoldToken() {
    //let { totalWintoken } = await referralTokens();
    var sold = await getInfo();
    sold = sold;
    let total = 200000;
    setsoldtokens(sold);
    const soldOutPerc = (sold / total) * 100;
    setremaning(soldOutPerc)
  }

  return (
    <>
      {localStorage.getItem("WinChoToken") ? <Navbarinner /> : <MyNavbar />}

      <div className="token_page">
        <div className="ban_sec_head text-center">
          <Container>
            <h1 className="tittle ">Token Information</h1>
            {/* <div className="token_info_card">
              <div className="black_card">
                <h6>AI Bot Rentals</h6>
                <p>
                  Developers rent out AI bots for WIN, while users pay WIN to
                  access automated strategies.
                </p>
              </div>
              <div className="black_card">
                <h6>Spend WIN</h6>
                <p>
                  {" "}
                  Spend WIN in games integrated with Wincho’s own ecosystem Live
                  Cockfight and Live Rabbithole.
                </p>
              </div>
              <div className="black_card">
                <h6>Voting Rights</h6>
                <p>
                  {" "}
                  Stakers influence platform decisions for token burns, game
                  launches.
                </p>
              </div>
              <div className="black_card">
                <h6>Leaderboard Rewards</h6>
                <p>
                  Traders who rank high on the leaderboard receive exclusive
                  bonuses, such as additional WIN tokens
                </p>
              </div>
              <div className="black_card">
                <h6>Tournament Prizes</h6>
                <p>
                  Participate in trading tournaments with massive WIN token
                  prize pools.
                </p>
              </div>
            </div> */}
            <Row className="token_info_card">
              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>Rewards</h6>
                  <p>
                    Earn WIN for winning matches, completing challenges, or
                    contributing to the community.
                  </p>
                </div>
              </Col>
              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>AI Bot Rentals</h6>
                  <p>
                    Developers rent out AI bots for WIN,
                    while users pay WIN to access automated strategies.
                  </p>
                </div>
              </Col>
              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>Voting Rights</h6>
                  <p>
                    {" "}
                    Stakers influence platform decisions for token burns, game
                    launches.
                  </p>
                </div>
              </Col>
              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>Leaderboard Rewards</h6>
                  <p>
                    Traders who rank high on the leaderboard receive exclusive
                    bonuses, such as additional WIN tokens
                  </p>
                </div>
              </Col>

              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>Tournament Prizes</h6>
                  <p>
                    Participate in trading tournaments with massive WIN token
                    prize pools.
                  </p>
                </div>
              </Col>
              <Col lg="4" md="6" className="mb-4">
                <div className="black_card">
                  <h6>Spend WIN</h6>
                  <p>
                    {" "}
                    Spend WIN in games integrated with Wingo’s own ecosystem
                    Live Cockfight and Live Rabbithole.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="ban_sec_head text-center">
          <Container>
            <h1 className="tittle mb-5">Token Presale Details </h1>
            <div
              className="progress"
              role="progressbar"
              aria-label="Example with label"
              aria-valuemin={0}
              aria-valuemax={100}
            >
              <div className="progress-bar" style={{ width: `${remaning}%` }} />
            </div>
            <p className="progress-title">
              {" "}
              {soldtokens} Win<span>Total Token : 200k Win</span>
            </p>
          </Container>
        </div>
        <div className="ban_sec_head text-center">
          <h1 className="tittle ">Token Distribution</h1>
          <p className="para">
            Join the industry leaders to discuss where the markets are heading.
            We accept token payments.
          </p>
          <h4 className="total_supply">Total Supply- 10M WIN</h4>
        </div>

        <div className="chart_heading">
          <Container>
            <div className="chart_head">
              <div className="chart_head_box">
                <div
                  className="canva_piechart"
                  style={{
                    position: "relative",
                    width: "300px",
                    height: "350px",
                    color: "#fff",
                    textAlign: "center",
                  }}
                >
                  <Doughnut data={data} options={options} />
                </div>
              </div>
              <div
                className="canva_lable"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                  marginTop: "20px",
                }}
              >
                {labels.map((label, index) => (
                  <div
                    key={index}
                    className="canva_piechart_flex"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "24px",
                      height: "max-content",
                    }}
                  >
                    <div
                      className="canva_piechart_bar"
                      style={{
                        width: "2px",
                        height: "115px",
                        backgroundColor: colors[index],
                        margin: "5px 0",
                        borderRadius: "50px",
                      }}
                    />
                    <div
                      className="canva_piechart_header"
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        flexDirection: "column",
                      }}
                    >
                      <span className="canva_piechart_head">
                        {percentages[index]}%
                      </span>

                      <span
                        className="canva_piechart_head_sub"
                        style={{
                          color: colors[index],

                          textAlign: "start",
                        }}
                      >
                        {label}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Container>
        </div>

        <div class=" sec_2">
          <Container>
            <div className="sec2_token">
              <h1 className="tittle text-center mb-5">Our Roadmap</h1>
              <div className="slide_head ">
                <Slider {...settings}>
                  {slides.map((slide, index) => {
                    const isFirst = index === firstVisible;
                    const isLast = index === firstVisible + slidesToShow - 1;
                    return (
                      <div
                        key={slide.id}
                        className={`slider_item ${isFirst || isLast ? "no-border" : ""
                          }`}
                      >
                        <div className="heading_slide">
                          <h5>Phase {index + 1}</h5>
                        </div>
                        <div className="slider_box">
                          <h6>{slide.title}</h6>
                          <p>{slide.desc}</p>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <MyFooter />
    </>
  );
}
